import { NgModule } from "@angular/core";
import { KanbanFormComponent } from './kanban-form/kanban-form.component';
import { DynamicKanbanComponent } from './dynamic-kanban.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { KanbanDesignComponent } from './kanban-design/kanban-design.component';
import { KanbanResultComponent } from './kanban-result/kanban-result.component';
import { MaterialModule } from '../../material.module';
import { KendoModule } from '../kendo.module';
import { AbwConditionalFormatingModule } from '../@core/abw-conditional-text-formating.module';
import { MdKanbanFormAddTaskDialogComponent } from "./kanban-form/@modals/md-kanban-form-add-task-dialog/md-kanban-form-add-task-dialog.component";
import { MdKanbanFormChequeDepotDialogComponent } from "./kanban-form/@modals/md-kanban-form-cheque-depot-dialog/md-kanban-form-cheque-depot-dialog.component";
import { MdKanbanFormChequeRetraitDialogComponent } from "./kanban-form/@modals/md-kanban-form-cheque-retrait-dialog/md-kanban-form-cheque-retrait-dialog.component";
import { MdKanbanFormFactureDepotDialogComponent } from "./kanban-form/@modals/md-kanban-form-facture-depot-dialog/md-kanban-form-facture-depot-dialog.component";
import { MdKanbanFormChequeDepotItemDialogComponent } from "./kanban-form/@modals/md-kanban-form-cheque-depot-item-dialog/md-kanban-form-cheque-depot-item-dialog.component";
import { AbwConfirmDialogModule } from "../../abw-confirm-dialog/abw-confirm-dialog.module";

@NgModule({
    declarations: [
        KanbanResultComponent,
        KanbanDesignComponent,
        MdKanbanFormAddTaskDialogComponent, MdKanbanFormChequeDepotDialogComponent, MdKanbanFormChequeRetraitDialogComponent, MdKanbanFormFactureDepotDialogComponent, MdKanbanFormChequeDepotItemDialogComponent,
        KanbanFormComponent, DynamicKanbanComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MaterialModule,
        KendoModule,
        AbwConditionalFormatingModule,
        AbwConfirmDialogModule
    ],
    entryComponents: [
        DynamicKanbanComponent,
        MdKanbanFormAddTaskDialogComponent,
        MdKanbanFormChequeDepotDialogComponent,
        MdKanbanFormChequeRetraitDialogComponent,
        MdKanbanFormFactureDepotDialogComponent,
        MdKanbanFormChequeDepotItemDialogComponent
    ]
})
export class KanbanModule {}